export const EndPointsConfig = {
    SystemPrompt: 'formulate_stream?'
}